import styled from 'styled-components';

export const Container = styled.div`
    border: 1px solid #ddd;
    height: 100%;
`;
